import {updateField} from "vuex-map-fields"
import {getDefaultState} from "./ocaTypeState"

export default {
	updateField,
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	SET_OCATYPES(state, payload) {
		state.ocatypes = payload
	},
	SET_OCATYPE(state, payload) {
		state.ocatype = payload
	},
	SET_VALIDATION_ERRORS(state, payload) {
		for (const key in payload) {
			state.validation_ocatype[key] = '* '+payload[key][0]
		}
	},
	CLEAR_VALIDATION(state) {
		for (const key in state.validation_ocatype) {
			state.validation_ocatype[key] = null
		}
	},
}